import * as React from 'react';
import { withRouter } from 'react-router';

import { CardTypeTypes } from 'types/Card';
import { WithRouterType } from 'types/withRouter';

import { generateClassNameString } from 'helper/css';

import Icon from 'components/atoms/Icon';
import CardDetailOptional from 'components/molecules/Card/Fragments/CardDetailOptional';
import CardHeader from 'components/molecules/Card/Fragments/CardHeader';
import CategoryTitle from 'components/molecules/Card/Fragments/CategoryTitle';
import CompleteIcon from 'components/molecules/Card/Fragments/CompleteIcon';
import PlaceholderImage from 'components/molecules/Card/Fragments/PlaceholderImage';
import TopicIcon from 'components/molecules/Card/Fragments/TopicIcon';

export type OptionalCardPropsType = {
	id: any;
	externalId: string;
	title: string;
	text: string;
	categoryIcon: string;
	type: CardTypeTypes;
	previewImage?: any;
	programItemRef?: string;
	currentDayNumber: number;
	doSetProgramItemRef: (programItemRef: string, programItemExternalRef?: string) => void;
	doSetDayRef: (day: any) => void;
};

export type OptionalCardPropsMerged = OptionalCardPropsType & WithRouterType;

export class OptionalCard extends React.Component<OptionalCardPropsMerged> {
	public static displayName = 'OptionalCard';

	public render() {
		if (!this.props.type) {
			return null;
		}

		const FixtureCardDetailOptional: React.ComponentType<any> = CardDetailOptional as any;

		return (
			<article
				// component="article"
				className={`${generateClassNameString('m-card', [this.props.type])} state-m-card--feed`}
			>
				<div className="m-card__card">
					<div className="m-card__scroll">
						<div className="m-card__layer-icon">
							<Icon iconName={this.props.categoryIcon} />
						</div>
						<div className="m-card__inner">
							<PlaceholderImage
								type={this.props.type}
								previewImage={this.props.previewImage}
								id={this.props.id}
							/>
							<div className="m-card__category-icon">
								<Icon iconName={this.props.categoryIcon} />
							</div>
							<div className="m-card__topic">
								<CategoryTitle type={this.props.type} />
								<TopicIcon categoryIcon={this.props.categoryIcon} />
								<CompleteIcon />
								{/* <CompleteIcon type={this.props.type as any} /> */}
							</div>
							<div className="m-card__wrapper">
								<CardHeader {...this.props} />
								<FixtureCardDetailOptional
									parentProps={this.props}
									title={this.props.title}
									text={this.props.text}
									id={this.props.id}
									type={this.props.type}
									categoryIcon={this.props.categoryIcon}
									history={this.props.history}
									location={this.props.location}
									match={this.props.match}
									doSetProgramItemRef={this.props.doSetProgramItemRef}
									doSetDayRef={this.props.doSetDayRef}
									currentDayNumber={this.props.currentDayNumber}
									programItemRef={this.props.programItemRef}
								/>
							</div>
						</div>
					</div>
				</div>
			</article>
		);
	}
}

export default withRouter(OptionalCard as any);
